/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impersonation_View_As_ActionInputs */

const vi_impersonation_view_as_action = /** @type {(inputs: Impersonation_View_As_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem với tư cách`)
};

/**

* @param {Impersonation_View_As_ActionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const impersonation_view_as_action = /** @type {((inputs?: Impersonation_View_As_ActionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impersonation_View_As_ActionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_impersonation_view_as_action(inputs)
});